const ATTRIBUTION_KEY = 'voice2doc_attribution_key';

export function getStoredAttributionKey(): string | null {
  return sessionStorage.getItem(ATTRIBUTION_KEY);
}

/**
 * Захватывает attribution key из URL при загрузке страницы.
 * Вызывать на уровне модуля (до React render).
 *
 * Сохраняет key в sessionStorage, очищает URL.
 */
export function captureAttributionFromUrl(): void {
  const params = new URLSearchParams(window.location.search);
  const attributionKey = params.get('attribution');

  if (!attributionKey) return;

  sessionStorage.setItem(ATTRIBUTION_KEY, attributionKey);

  // Очищаем URL от параметра attribution
  params.delete('attribution');
  const cleanSearch = params.toString();
  const cleanUrl = window.location.pathname + (cleanSearch ? `?${cleanSearch}` : '') + window.location.hash;
  window.history.replaceState({}, '', cleanUrl);
}
